import { useState } from 'react';
import { Grid, TextField, makeStyles, Button, withStyles } from '@material-ui/core';
import FormLabel from '@material-ui/core/FormLabel';
import { addParticipantsBysessionCode } from '../../../../store/actions/participant/experience';
import { useDispatch, useSelector } from 'react-redux';
import {Loading} from '../../../atoms/commonLoadings';
import CustomSnackBar from '../../../pages/creator/experienceManager/participantsDashboard/component/CustomSnackBar';

const useStyles = makeStyles(() => ({
    container: {
        flex: 1,
        marginTop: 17,
        paddingLeft: 20,
        paddingRight: 20
    },
    header: {
        fontSize: '48px!important',
        fontFamily: 'Spartan-bold',
        fontWeight: 400,
        lineHeight: 1.3,
        letterSpacing: '0em',
        color: '#212D40',
        textAlign: 'center'
    },
    img: {
        width: 317,
        height: 204,
        '@media (max-width: 1400px)': {
            width: 285,
            height: 166,
        },
    },
    content: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center'
    },
    btn: {
        padding: '6px 27px',
        background: '#017AEF',
        color: '#fff',
        '&:hover': {
            background: '#0f9fef',
            color: '#fff',
        },
        textTransform: 'none'
    },
    icon: {
        marginLeft: 10
    },
    btnBox: {
        width: '100%',
        maxWidth: 530,
        display: 'flex',
        justifyContent: 'flex-end',
        margin: 12
    },
    label: {
        fontSize: 16,
        fontFamily: 'roboto-black',
        color: '#697683',
        marginTop: 50,
        textAlign: 'left',
        marginBottom: -38,
        '& .MuiFormLabel-asterisk': {
            color:"red"
    }
    },
}));

const CssTextField = withStyles({
    root: {
        marginTop: 40,
        maxWidth: 530,
        '& label.MuiFormLabel-root': {
            color: '#697683',
            fontFamily: 'roboto-black',
            fontSize: 16,
        },
        '& .MuiInputBase-input': {
            fontFamily: 'roboto-light',
            fontSize: 24,
            color: '#8F99A3'
        }
    },
})(TextField);

function PlanningStep3() {

    const classes = useStyles();
    const [url, setUrl] = useState<string>('');
    const dispatch = useDispatch();
    const [loading, setLoading] = useState(false);
    const apolloClient = useSelector((state: any) => state.apolloClient);
    const [snackAlertType, handleSnackAlertType] = useState('');
    const [snackAlertMsg, handleSnackMsg] = useState('');
    const [isShownSnackAlert, setShownSnackAlert] = useState(false);
    const loginUserData = JSON.parse(localStorage.getItem("user_data") || "{}")

    function hideSnackAlert() {
      setShownSnackAlert(false);
      handleSnackAlertType('')
      handleSnackMsg('')
    }

    const onGoNextPage = () => {
        // if(url && url.substring(url.lastIndexOf('/') + 1) && loginUserData.username){
        if(loginUserData.username){
            setLoading(true);
            const request = {
                // session_code:url.substring(url.lastIndexOf('/') + 1),
                session_code: url,
                email:loginUserData.username
            }
            let errorMessage = "Problem occured while add participant"
            dispatch(addParticipantsBysessionCode(apolloClient.client, request, (response: any) => {
                setLoading(false);
                if (response) {
                    if(response.status === "true"){
                        window.location.replace('/participant/dashboard')
                    } else {
                        setShownSnackAlert(true);
                        handleSnackAlertType('error')
                        if(response.message){
                            errorMessage = response.message
                        }
                        handleSnackMsg(errorMessage)
                    }
                } else {
                    setShownSnackAlert(true);
                    handleSnackAlertType('error')
                    handleSnackMsg(errorMessage)
                }
            }));
        }
    }

    return (
        <Grid container justifyContent={'center'} className={classes.container}>
            <Grid item lg={7} md={10} sm={12} className={classes.content}>

                <p className={classes.header}>
                  Awesome.<br />
                  Just copy the link you received<br />
                  into the box below.<br />
                </p>

                <img
                    className={classes.img}
                    alt="{img}"
                    src={"/assets/icons/participant/participant_awesome.svg"}
                />

                <div className={classes.btnBox} style={{ justifyContent: 'flex-start' }}>
                    {/*<FormLabel className={classes.label} required>*/}
                    <FormLabel className={classes.label}>
                        Paste the link you received in the space below
                    </FormLabel>
                </div>

                <CssTextField
                    fullWidth
                    margin="normal"
                    name="linkUrl"
                    value={url}
                    onChange={e => setUrl(e.target.value)}
                />

                {!loading && (<div className={classes.btnBox}>
                    <Button variant='contained' className={classes.btn} onClick={onGoNextPage}>
                        Submit
                        <img src={'/assets/icons/arrow-right-circle.svg'} alt="{}" className={classes.icon} />
                    </Button>
                </div>)}
                {
                    loading && <Loading />
                }
                <CustomSnackBar type={snackAlertType} message={snackAlertMsg} open={isShownSnackAlert} onClose={hideSnackAlert} />
            </Grid>
        </Grid>

    )
}

export default PlanningStep3;